import {
	CompanyNode,
	OtherNode,
	PartnershipNode,
	TrustNode,
} from '@dealstack/frontend/app/pages/Project/Cap/CapChartPage/CapChart/Nodes';
import { DebtEdge } from '@dealstack/frontend/app/pages/Project/Cap/CapChartPage/CapChart/Edges';
import { Edge, Node } from '@dealstack/shared/lib/generated';
import { Position, StepEdge } from '@xyflow/react';
import { SmartStepEdge } from '@dealstack/frontend/app/pages/Project/Cap/CapChartPage/CapChart/SmartEdge/SmartStepEdge/SmartStepEdge';

export enum NodeTypes {
	PARTNERSHIP = 'partnership',
	COMPANY = 'company',
	OTHER = 'other',
	TRUST = 'trust',
}

export enum EdgeTypes {
	EQUITY = 'equity',
	DEBT = 'debt',
}

export const nodeTypes = {
	[NodeTypes.PARTNERSHIP]: PartnershipNode,
	[NodeTypes.COMPANY]: CompanyNode,
	[NodeTypes.OTHER]: OtherNode,
	[NodeTypes.TRUST]: TrustNode,
};

export const edgeTypes = {
	[EdgeTypes.DEBT]: DebtEdge,
	[EdgeTypes.EQUITY]: SmartStepEdge,
};

export const edgeTypesFast = {
	[EdgeTypes.DEBT]: DebtEdge,
	[EdgeTypes.EQUITY]: StepEdge,
};

export type NodeLoanData = {
	source: boolean;
	target: boolean;
	sourcePosition?: Position | null;
};

export type NodeData = {
	label: string;
	registeredId?: string;
	isMipGroup: boolean;
	registeredName?: string;
	countryCode?: string;
	loanData?: NodeLoanData;
};

export type NodeRes = Node;
export type EdgeRes = Edge;
